<template>
  <ul v-if="photos.length > 0" class="photo-tab-view">
    <li v-for="(photo, index) in photos" :key="index">
      <img :src="photo.url" alt="" />
    </li>
  </ul>
  <div v-else-if="alreadyChange" class="un-upload">
    <img
      class="icon"
      src="../../../assets/personal/un_upload_photo@2x.png"
      alt=""
    />
    <p>ta还没有上传照片</p>
  </div>
  <ml-loading v-else class="loading" />
</template>

<script>
export default {
  name: "PhotoTabView",
  props: {
    photos: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // 还未加载数据的时候显示：加载中
      // 更新了数据之后为空：提示上传数据
      // 更新了数据不为空：展示数据
      alreadyChange: false
    };
  },
  watch: {
    photos() {
      this.alreadyChange = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.photo-tab-view {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto;
  grid-gap: 10px;
  li {
    width: 168px;
    height: 168px;
    border-radius: 5px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.un-upload {
  margin-top: 40px;
  display: flex;
  align-items: center;
  flex-direction: column;
  .icon {
    width: 76px;
    height: 76px;
  }
  p {
    margin-top: 24px;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    line-height: 20px;
  }
}
</style>
